export class ApiError extends Error {
  status: number
  corpo: Record<string, unknown>

  constructor(status: number, corpo: Record<string, unknown>) {
    super((corpo.erro as string) || `Erro ${status}`)
    this.status = status
    this.corpo = corpo
  }
}

function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}

async function request<T>(metodo: string, caminho: string, corpo?: unknown): Promise<T> {
  const resposta = await fetch(`/api${caminho}`, {
    method: metodo,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
    body: corpo === undefined ? undefined : JSON.stringify(corpo),
  })

  // O Devise responde 401 com redirect para o login quando a sessão cai.
  if (resposta.status === 401) {
    window.location.href = "/login"
    throw new ApiError(401, { erro: "Sessão expirada" })
  }

  const texto = await resposta.text()
  const dados = texto ? JSON.parse(texto) : {}

  if (!resposta.ok) throw new ApiError(resposta.status, dados)
  return dados as T
}

export const api = {
  get: <T,>(caminho: string) => request<T>("GET", caminho),
  post: <T,>(caminho: string, corpo?: unknown) => request<T>("POST", caminho, corpo),
  patch: <T,>(caminho: string, corpo?: unknown) => request<T>("PATCH", caminho, corpo),
}
